import { Box } from "@material-ui/core"
import type { ReactElement, ReactNode } from "react"

export interface ICardTemplateContainerProps {
  columns: number
  children?: ReactNode
  className?: string
}

export function CardTemplateContainer(props: ICardTemplateContainerProps): ReactElement {
  const { columns, children, className } = props

  function getGridTemplateColumns(): string {
    const templateColumns: string[] = []
    for (let index = 0; index < columns; index++) {
      templateColumns.push("1fr")
    }
    return templateColumns.join(" ")
  }

  return (
    <Box
      className={`map-card-container ${className || ""}`}
      display="grid"
      gridGap="2.4rem"
      gridTemplateColumns={getGridTemplateColumns()}
    >
      {children}
    </Box>
  )
}
